import { useQuery } from "react-query";
import { CommApiInstance } from "Utils/CommApiInstance";

const TrmsLstInqApi = async (
    gameSvcCd:string        ,
    trmsKindCd:string       ,
) => {
    return await CommApiInstance.post(`${"/"+gameSvcCd + "/trms/"+trmsKindCd+"/trms_lst"}`,{
        apiBody: {
            
        }
    })
    .then((Resp) => Resp.data);
}

export default TrmsLstInqApi;